<y42-smart-btn
  [disabled]="state.isDisabled"
  [pending]="false"
  [type]="'button'"
  [class]="'fs-08 bg-orange-700 font-medium ' + class"
  (click)="commitClick()"
  matTooltip="{{ state.isDisabled ? 'Make some changes to commit' : 'Please commit changes to take effect' }}"
>
  <fa-icon class="fs-09" [icon]="['fal', 'code-commit']"></fa-icon>
</y42-smart-btn>
